import { Flex } from '@chakra-ui/react'

import { CALENDER_QUERIES } from '../../Calendar/styles/responsive'
import { CalendarGrid } from './CalendarGrid'
import { CalendarHeader } from './CalendarHeader'

export const CalendarView = () => {
	return (
		<Flex
			p="20px"
			flexDir="column"
			gap={3}
			sx={{
				[CALENDER_QUERIES.xs]: {
					p: '12px',
				},
			}}
		>
			<CalendarHeader />
			<CalendarGrid />
		</Flex>
	)
}
